(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Scrolling-logos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  window.onhowScrollingLogos = window.onhowScrollingLogos || {};
  window.onhowScrollingLogos.initializedSections = window.onhowScrollingLogos.initializedSections || {};
  window.onhowScrollingLogos.pendingTimeouts = window.onhowScrollingLogos.pendingTimeouts || {};
  window.onhowScrollingLogos.lastResize = window.onhowScrollingLogos.lastResize || 0;
  let hasInitialized = false;

  function initializeSections() {
    if (hasInitialized) return;
    hasInitialized = true;

    for (let id in window.onhowScrollingLogos.pendingTimeouts) {
      clearTimeout(window.onhowScrollingLogos.pendingTimeouts[id]);
    }
    window.onhowScrollingLogos.pendingTimeouts = {};

    const sections = document.querySelectorAll('.onhow-scrolling-logos-section');
    sections.forEach((section) => {
      const sectionId = section.id || `section-${Math.random().toString(36).substr(2, 9)}`;
      if (window.onhowScrollingLogos.initializedSections[sectionId]) return;
      window.onhowScrollingLogos.initializedSections[sectionId] = true;

      window.onhowScrollingLogos.pendingTimeouts[sectionId] = setTimeout(() => {
        initSection(section);
        delete window.onhowScrollingLogos.pendingTimeouts[sectionId];
      }, 200);
    });
  }

  async function initSection(section) {
    const track = section.querySelector('.onhow-scrolling-logos-track');
    if (!track) return;

    track.classList.remove('onhow-initialized');
    await preloadImages(track);
    setupTrack(track);

    const pauseEnabled = section.dataset.pauseOnHover === "true";
    section.dataset.pauseEnabled = pauseEnabled ? "true" : "false";
    if (pauseEnabled) addPauseEvents(section);
  }

  function addPauseEvents(section) {
    if (section.dataset.pauseEnabled !== "true") return;
    const inners = section.querySelectorAll('.onhow-scrolling-logos-inner');

    section.addEventListener('mouseenter', () => {
      inners.forEach(inner => inner.style.animationPlayState = 'paused');
    });
    section.addEventListener('mouseleave', () => {
      inners.forEach(inner => inner.style.animationPlayState = 'running');
    });

    section.addEventListener('touchstart', () => {
      inners.forEach(inner => inner.style.animationPlayState = 'paused');
    });
    section.addEventListener('touchend', () => {
      inners.forEach(inner => inner.style.animationPlayState = 'running');
    });
  }

  function handleResize() {
    const now = Date.now();
    if (now - window.onhowScrollingLogos.lastResize < 1000) return;

    const sections = document.querySelectorAll('.onhow-scrolling-logos-section');
    let shouldReinitialize = false;

    sections.forEach((section) => {
      const track = section.querySelector('.onhow-scrolling-logos-track');
      if (!track) return;
      const container = track.parentElement;
      const currentWidth = container.offsetWidth;
      const storedWidth = parseFloat(section.getAttribute('data-last-width') || '0');
      if (storedWidth === 0) {
        section.setAttribute('data-last-width', currentWidth);
        return;
      }
      if (Math.abs(currentWidth - storedWidth) > 20) {
        shouldReinitialize = true;
        section.setAttribute('data-last-width', currentWidth);
      }
    });

    if (shouldReinitialize) {
      window.onhowScrollingLogos.lastResize = now;
      hasInitialized = false;
      window.onhowScrollingLogos.initializedSections = {};
      initializeSections();
    }
  }

  function preloadImages(track) {
    return new Promise((resolve) => {
      const images = track.querySelectorAll('img');
      let loadedCount = 0;
      const totalImages = images.length;
      if (totalImages === 0) { resolve(); return; }
      const checkComplete = () => { loadedCount++; if (loadedCount >= totalImages) resolve(); };
      images.forEach(img => {
        if (img.complete) { checkComplete(); return; }
        const tempImg = new Image();
        tempImg.onload = tempImg.onerror = checkComplete;
        tempImg.src = img.src;
      });
    });
  }

  function setupTrack(track) {
    const inner1 = track.querySelector('.onhow-scrolling-logos-inner--1');
    const inner2 = track.querySelector('.onhow-scrolling-logos-inner--2');
    if (!inner1 || !inner2) return;

    // --- NEW: always reset to the original HTML before we clone ---
    if (track.dataset.baseInner1) {
      inner1.innerHTML = track.dataset.baseInner1;
      inner2.innerHTML = track.dataset.baseInner2 || '';
    } else {
      track.dataset.baseInner1 = inner1.innerHTML;
      track.dataset.baseInner2 = inner2.innerHTML;
    }
    // --------------------------------------------------------------

    const section = track.closest('.onhow-scrolling-logos-section');
    const containerWidth = track.parentElement.offsetWidth;
    section.setAttribute('data-last-width', containerWidth);

    // stop any previous animation
    inner1.style.animation = 'none';
    inner2.style.animation = 'none';
    void inner1.offsetWidth; 
    void inner2.offsetWidth;

    const originalItems = inner1.querySelectorAll('.onhow-logo-item');
    if (originalItems.length === 0) return;

    const clonedItems = Array.from(originalItems).map(item => item.cloneNode(true));
    inner1.innerHTML = '';
    inner2.innerHTML = '';

    clonedItems.forEach(item => inner1.appendChild(item.cloneNode(true)));

    const measuredItems = inner1.querySelectorAll('.onhow-logo-item');
    const originalWidth = Array.from(measuredItems).reduce((sum, item) => {
      const style = window.getComputedStyle(item);
      return (
        sum +
        item.offsetWidth +
        parseFloat(style.marginLeft) +
        parseFloat(style.marginRight)
      );
    }, 0);

    const baseScrollSpeed = parseFloat(section.dataset.scrollSpeed) || 60;
    const desiredPxPerSec = originalWidth / baseScrollSpeed;
    const containerWidthForCalc = track.parentElement.offsetWidth;
    const minTargetWidth = containerWidthForCalc * 3;
    const duplicatesNeeded = Math.max(1, Math.ceil(minTargetWidth / originalWidth) - 1);

    for (let i = 0; i < duplicatesNeeded; i++) {
      clonedItems.forEach(item => {
        inner1.appendChild(item.cloneNode(true));
        inner2.appendChild(item.cloneNode(true));
      });
    }
    // one more copy for inner2’s initial offset
    clonedItems.forEach(item => inner2.appendChild(item.cloneNode(true)));

    const finalWidth = originalWidth * (duplicatesNeeded + 1);
    inner1.style.width = `${finalWidth}px`;
    inner2.style.width = `${finalWidth}px`;
    inner2.style.transform = `translateX(${finalWidth}px)`;

    // duration is derived from speed + track width, but now uses a stable base
    const adjustedDuration = finalWidth / desiredPxPerSec;

    setTimeout(() => {
      inner1.style.animation = `onhow-scroll-1 ${adjustedDuration}s linear infinite`;
      inner2.style.animation = `onhow-scroll-2 ${adjustedDuration}s linear infinite`;
      track.classList.add('onhow-initialized');
    }, 50);
  }

  function debounce(func, wait) {
    let timeout;
    return function() {
      const context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSections);
  } else {
    initializeSections();
  }

  window.addEventListener('load', initializeSections);
  window.addEventListener('resize', debounce(handleResize, 500));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
